(() => {
  const root = document.querySelector("[data-product-app]");
  if (!root) return;

  const dataEl = root.querySelector("[data-product-json]");
  if (!dataEl) return;
  let data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch {
    return;
  }

  const gallery = root.querySelector("[data-product-gallery]");
  const track = root.querySelector("[data-gallery-track]");
  const thumbs = [...root.querySelectorAll("[data-thumb]")];
  const slides = [...root.querySelectorAll("[data-gallery-slide]")];
  const lightboxTrack = root.querySelector("[data-lightbox-track]");
  const lightboxSlides = [...root.querySelectorAll("[data-lightbox-slide]")];
  const form = root.querySelector("[data-product-form]");
  const idInput = root.querySelector("[name='id']");
  const priceHost = root.querySelector("[data-price-host]");
  const stockHost = root.querySelector("[data-stock-host]");
  const skuHost = root.querySelector("[data-sku-host]");
  const submitBtn = root.querySelector("[data-add-cart]");
  const buyBtn = root.querySelector("[data-buy-now]");
  const optionGroups = [...root.querySelectorAll("[data-option-group]")];
  const threshold = Number(root.dataset.lowStock || 5);
  let index = 0;

  const selected = (data.options || []).map((_, i) => {
    const current = data.variants.find((v) => v.id === data.current_variant_id) || data.variants[0];
    return current ? current.options[i] : data.variants[0]?.options[i];
  });

  function findVariant() {
    return data.variants.find((v) => v.options.every((opt, i) => opt === selected[i])) || null;
  }

  function isLowStock(variant) {
    if (!variant || !variant.available) return false;
    if (!variant.inventory_management && !(Number(variant.inventory_quantity) > 0)) return false;
    const qty = Number(variant.inventory_quantity);
    return !Number.isNaN(qty) && qty <= threshold;
  }

  function stockText(variant) {
    const t = window.themeI18n?.t || ((k) => k);
    if (!variant || !variant.available) return { label: t("out_of_stock"), cls: "stock-sold" };
    if (isLowStock(variant)) return { label: t("low_stock"), cls: "stock-note" };
    return { label: t("in_stock"), cls: "stock-ok" };
  }

  function syncLowBadge(variant) {
    const host = root.querySelector("[data-product-badges]");
    if (!host) return;
    let low = host.querySelector(".badge-low");
    if (isLowStock(variant)) {
      if (!low) {
        low = document.createElement("span");
        low.className = "badge badge-low";
        low.textContent = "Low stock";
        host.appendChild(low);
      }
    } else if (low) {
      low.remove();
    }
  }

  const lightbox = root.querySelector("[data-lightbox]");
  const lightboxCount = root.querySelector("[data-lightbox-count]");
  const slideCount = slides.length;

  function setTrack(el, i, instant) {
    if (!el) return;
    el.style.transition = instant ? "none" : "";
    el.style.transform = `translate3d(-${i * 100}%, 0, 0)`;
    if (instant) {
      el.offsetHeight;
      el.style.transition = "";
    }
  }

  function pauseMedia(scope) {
    if (!scope) return;
    scope.querySelectorAll("video").forEach((video) => video.pause());
  }

  function playActive() {
    const open = lightbox && !lightbox.hidden;
    const current = open ? lightboxSlides[index] : slides[index];
    pauseMedia(root);
    if (!current) return;
    current.querySelector("deferred-media")?.loadContent?.();
    const video = current.querySelector("video");
    if (video) {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.play().catch(() => {});
    }
  }

  function syncLightbox() {
    if (!lightbox || lightbox.hidden) return;
    setTrack(lightboxTrack, index, false);
    if (lightboxCount) lightboxCount.textContent = `${index + 1} / ${slideCount}`;
    playActive();
  }

  function openLightbox() {
    if (!lightbox || !slideCount) return;
    lightbox.hidden = false;
    document.body.style.overflow = "hidden";
    setTrack(lightboxTrack, index, true);
    if (lightboxCount) lightboxCount.textContent = `${index + 1} / ${slideCount}`;
    warmLightbox(index);
    playActive();
  }

  function closeLightbox() {
    if (!lightbox) return;
    pauseMedia(lightbox);
    lightbox.hidden = true;
    document.body.style.overflow = "";
    playActive();
  }

  const warmed = new WeakSet();
  function warm(img) {
    if (!img || warmed.has(img)) return;
    warmed.add(img);
    img.loading = "eager";
    const decode = () => img.decode?.().catch(() => {});
    if (img.complete) decode();
    else img.addEventListener("load", decode, { once: true });
  }

  function eager(i) {
    const n = (i + slideCount) % slideCount;
    warm(slides[n]?.querySelector("img"));
    if (lightbox && !lightbox.hidden) warm(lightboxSlides[n]?.querySelector("img"));
  }

  function warmLightbox(from) {
    if (!lightboxSlides.length) return;
    warm(lightboxSlides[from]?.querySelector("img"));
    eager(from + 1);
    eager(from - 1);
    const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 250));
    idle(() => lightboxSlides.forEach((slide) => warm(slide.querySelector("img"))));
  }

  let pending = null;
  function goTo(i) {
    if (!slideCount) return;
    index = (i + slideCount) % slideCount;
    if (pending) cancelAnimationFrame(pending);
    pending = requestAnimationFrame(() => {
      pending = null;
      const lightboxOpen = lightbox && !lightbox.hidden;
      setTrack(track, index, lightboxOpen);
      thumbs.forEach((btn, n) => btn.classList.toggle("is-active", n === index));
      eager(index + 1);
      eager(index - 1);
      if (lightboxOpen) syncLightbox();
      else playActive();
    });
  }

  function showImageId(imageId) {
    if (!imageId) return;
    const i = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(imageId));
    if (i >= 0) goTo(i);
  }

  function paint(fromUser) {
    const variant = findVariant();
    optionGroups.forEach((group) => {
      const optIndex = Number(group.dataset.optionIndex);
      group.querySelectorAll("[data-option-value]").forEach((btn) => {
        const value = btn.dataset.optionValue;
        const trial = selected.slice();
        trial[optIndex] = value;
        const match = data.variants.find((v) => v.options.every((opt, i) => opt === trial[i]));
        btn.classList.toggle("is-selected", selected[optIndex] === value);
        btn.classList.toggle("is-unavailable", !match || !match.available);
      });
    });
    if (!variant) {
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = (window.themeI18n?.t || ((k) => k))("unavailable");
      }
      if (buyBtn) buyBtn.disabled = true;
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (skuHost) skuHost.textContent = variant.sku ? `Model / SKU: ${variant.sku}` : "";
    if (priceHost) {
      const fmt = window.themeMoney || ((cents) => variant.price_label);
      const t = window.themeI18n?.t || ((k) => k);
      if (variant.compare_at_price > variant.price) {
        const save = variant.compare_at_price - variant.price;
        priceHost.innerHTML = `<div class="price-stack">
          <div class="price-row price-row-lg">
            <div class="price-block"><span class="price-tag">${t("was")}</span><s class="price-compare" data-money data-cents="${variant.compare_at_price}">${fmt(variant.compare_at_price)}</s></div>
            <div class="price-block"><span class="price-tag">${t("now")}</span><span class="price price-sale" data-money data-cents="${variant.price}">${fmt(variant.price)}</span></div>
          </div>
          <p class="price-saving">${t("you_save")} <span data-money data-cents="${save}">${fmt(save)}</span></p>
        </div>`;
      } else {
        priceHost.innerHTML = `<div class="price-stack"><div class="price-row price-row-lg"><span class="price" data-money data-cents="${variant.price}">${fmt(variant.price)}</span></div></div>`;
      }
    }
    if (stockHost) {
      const stock = stockText(variant);
      stockHost.className = `stock-note ${stock.cls}`;
      stockHost.textContent = stock.label;
    }
    syncLowBadge(variant);
    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      const t = window.themeI18n?.t || ((k) => k);
      submitBtn.textContent = variant.available ? t("add_cart") : t("out_of_stock");
    }
    if (buyBtn) {
      buyBtn.disabled = !variant.available;
      buyBtn.dataset.productTitle = data.title || buyBtn.dataset.productTitle || "";
      buyBtn.dataset.productUrl = data.url || window.location.href;
      buyBtn.dataset.price = (window.themeMoney ? window.themeMoney(variant.price) : variant.price_label) || "";
      buyBtn.dataset.sku = variant.sku || "";
      const opts = (variant.options || []).filter((opt) => opt && opt !== "Default Title");
      buyBtn.dataset.variant = opts.join(" / ");
    }
    if (fromUser) showImageId(variant.featured_image_id);
  }

  optionGroups.forEach((group) => {
    const optIndex = Number(group.dataset.optionIndex);
    group.querySelectorAll("[data-option-value]").forEach((btn) => {
      btn.addEventListener("click", () => {
        selected[optIndex] = btn.dataset.optionValue;
        paint(true);
      });
    });
  });

  root.querySelector("[data-gallery-prev]")?.addEventListener("click", (e) => {
    e.stopPropagation();
    goTo(index - 1);
  });
  root.querySelector("[data-gallery-next]")?.addEventListener("click", (e) => {
    e.stopPropagation();
    goTo(index + 1);
  });
  thumbs.forEach((btn, i) => btn.addEventListener("click", () => goTo(i)));
  slides.forEach((slide, i) => {
    slide.addEventListener("click", (event) => {
      if (event.target.closest("model-viewer, video, iframe, .product-media-external")) return;
      goTo(i);
      openLightbox();
    });
  });
  root.querySelector("[data-lightbox-close]")?.addEventListener("click", (e) => {
    e.stopPropagation();
    closeLightbox();
  });
  root.querySelector("[data-lightbox-prev]")?.addEventListener("click", (e) => {
    e.stopPropagation();
    goTo(index - 1);
  });
  root.querySelector("[data-lightbox-next]")?.addEventListener("click", (e) => {
    e.stopPropagation();
    goTo(index + 1);
  });
  let boxStart = 0;
  let swiped = false;
  lightbox?.addEventListener("click", (e) => {
    if (swiped) {
      swiped = false;
      return;
    }
    if (e.target.closest("[data-lightbox-prev], [data-lightbox-next], [data-lightbox-close]")) return;
    closeLightbox();
  });
  document.addEventListener("keydown", (e) => {
    if (!lightbox || lightbox.hidden) return;
    if (e.key === "Escape") closeLightbox();
    if (e.key === "ArrowLeft") goTo(index - 1);
    if (e.key === "ArrowRight") goTo(index + 1);
  });
  lightbox?.addEventListener("touchstart", (e) => {
    boxStart = e.changedTouches[0].clientX;
    swiped = false;
  }, { passive: true });
  lightbox?.addEventListener("touchend", (e) => {
    if (e.target.closest("[data-lightbox-prev], [data-lightbox-next], [data-lightbox-close]")) return;
    const dx = e.changedTouches[0].clientX - boxStart;
    if (Math.abs(dx) > 40) {
      swiped = true;
      goTo(index + (dx < 0 ? 1 : -1));
    }
  }, { passive: true });

  let startX = 0;
  gallery?.addEventListener("touchstart", (e) => {
    startX = e.changedTouches[0].clientX;
  }, { passive: true });
  gallery?.addEventListener("touchend", (e) => {
    const dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) > 40) goTo(index + (dx < 0 ? 1 : -1));
  }, { passive: true });

  form?.addEventListener("submit", (e) => {
    const variant = findVariant();
    if (!variant || !variant.available) e.preventDefault();
  });

  const videoIndex = slides.findIndex((slide) => slide.dataset.mediaType === "video" || slide.dataset.mediaType === "external_video");
  goTo(videoIndex >= 0 ? videoIndex : 0);
  paint(false);
  document.addEventListener("sf-currency", () => paint(false));
  document.addEventListener("sf-lang", () => paint(false));
})();
